<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiArrowUpThin } from "@mdi/js";
export default {
  name: "MdiArrowUpThin",
  data() {
    return {
      svgPath: mdiArrowUpThin,
    };
  },
};
</script>
